// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HnFRN","icon":"styles_icon__26Y-q"};